export const capitalize = (string: string) => {
  if (typeof string !== 'string' || !string) {
    return string
  }

  const lower = string.toLowerCase();


  return lower[0].toUpperCase() + lower.slice(1);
}
